import React, { useRef } from 'react';
import './HomeView.css';
import 'intersection-observer';
import TextInput from '../TextInput/TextInput';
import Suggestion from '../Suggestion/Suggestion';
import orb from '../../Assets/Images/orb.png';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import { getSuggestions } from '../../store/Suggestions/SuggestionsSelectors';
import { sendMessageAction } from '../../store/Messages/MessagesActions';
import { getLimitReached } from '../../store/Messages/MessagesSelectors';
import { getTenantConfig } from '../../store/Config/configSelectors';

const HomeView = ({ setHome }) => {
  const dispatch = useDispatch();
  useRef(null);
  useSelector(getUserId);

  const suggestions = useSelector(getSuggestions);
  const limitReached = useSelector(getLimitReached);
  const { promptSuggestions, homeContentClass, homeContentStyle } = useSelector(getTenantConfig);

  const sendMessage = async message => {
    setHome(false);
    dispatch(sendMessageAction(message));
  };

  const renderSuggestions = suggestions => {
    return (
      <div className="home-suggestions">
        {suggestions.map((suggestion, index) => (
          <Suggestion
            key={index}
            text={suggestion}
            sendMessage={sendMessage}
            setHome={setHome}
          />
        ))}
      </div>
    );
  };

  return (
    <div
      className={`Home-content ${homeContentClass}`}
      style={homeContentStyle}
    >
      <img src={orb} className="ema-orb" alt="orb" />

      <div className="bottomHalf">
        {Array.isArray(suggestions) ? (
          // If suggestions are directly a flat array, render them
          renderSuggestions(suggestions)
        ) : (
          <>
            {suggestions.group1?.length > 0 && (
              <>
                {promptSuggestions?.group1Header && (
                  <div>{promptSuggestions.group1Header}</div>
                )}
                {renderSuggestions(suggestions.group1)}
              </>
            )}

            {suggestions.group2?.length > 0 && (
              <>
                {promptSuggestions?.group2Header && (
                  <div className="suggestionsHeader">
                    {promptSuggestions.group2Header}
                  </div>
                )}
                {renderSuggestions(suggestions.group2)}
              </>
            )}
          </>
        )}

        {!limitReached && (
          <div className="convInput">
            <TextInput
              placeholder="Ask a question..."
              style={{ marginLeft: '20px' }}
              disabled={false}
              onPress={message => {
                if (!limitReached) {
                  sendMessage({ type: 'user', message });
                }
              }}
            />
          </div>
        )}

        <div className="poweredByEma">Powered by Ema v1.0.3</div>
      </div>
    </div>
  );
};

export default HomeView;
